import copy from '../../demo/fixtures/w5/copy.json'
import { GlossaryText, Icon, Term } from '../../ui'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

const ownerLabels = { ai: 'AI', you: '你', info: '提示' } as const
const ownerIcons = { ai: 'sparkle', you: 'user', info: 'info' } as const
const parenTerms = { 投放期内频次: 'freq', 账户基准: 'base' } as const

function AlertMessage({ text }: { text: string }) {
  return text.split(/(投放期内频次|账户基准)/g).map((part, index) => {
    const termKey = parenTerms[part as keyof typeof parenTerms]
    return termKey
      ? <Term key={`${index}-${termKey}`} k={termKey} paren />
      : <GlossaryText key={`${index}-text`} text={part} />
  })
}

export function AlertList() {
  const { alerts } = useW5Live()
  return (
    <div data-scope="metric-alerts">
      <div className={styles.subhead}>
        <p className={styles.subheadTitle}>{copy.sections.alerts}</p>
        <p className={styles.subheadHint}>{copy.sections.alertsHint}</p>
      </div>
      <div className={styles.alerts}>
        {alerts.map((alert) => {
          const owner = alert.owner
          return (
            <div className={styles.alert} key={`${alert.object}-${alert.rule}`}>
              <div><span className={`${styles.severity} ${styles[alert.tone]}`}>{alert.tone === 'ok' ? '良好' : alert.level}</span></div>
              <div>
                <p className={styles.alertTitle}>{alert.object}</p>
                <p className={styles.alertMessage}><AlertMessage text={alert.message} /></p>
                <div className={styles.alertMeta}>
                  <span className={styles.ruleChip}><GlossaryText text={alert.rule} /></span>
                  <span className={`${styles.owner} ${styles[owner]}`}>
                    <Icon name={ownerIcons[owner]} size={12} strokeWidth={2} />
                    {ownerLabels[owner]}
                  </span>
                </div>
              </div>
              <div className={styles.alertAction}><GlossaryText text={alert.action} /></div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
